// ------------------------------------
// Constants
// ------------------------------------
export const SET_LOCALE = 'SET_LOCALE';

export function setLocale(config = {}) {
  return { type: SET_LOCALE, payload: config };
}



// WEBPACK FOOTER //
// ./src/redux/actions/i18n.js